import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { StreamingStrip } from "@/components/site/StreamingStrip";
import { Marquee } from "@/components/site/Marquee";
import { MusicBio } from "@/components/site/MusicBio";
import { Store } from "@/components/site/Store";
import { AppSection } from "@/components/site/AppSection";
import { Footer } from "@/components/site/Footer";
import { CartDrawer } from "@/components/site/CartDrawer";
import { scrollToId } from "@/lib/lenis";

export default function Home() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return undefined;
    const t = setTimeout(() => scrollToId(hash.slice(1)), 400);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <StreamingStrip />
        <Marquee />
        <MusicBio />
        <Store />
        <AppSection />
      </main>
      <Footer />
      <CartDrawer />
    </>
  );
}
